import styled from 'styled-components';

export const TriggerButton = styled.button`
  padding: 6px 16px;
  background: white;
  border: 1px solid #ccc;
  cursor: pointer;
  font-size: 0.875rem;
  height: 30px;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const PopupContainer = styled.div`
  background-color: white;
  border-radius: 8px;
  width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  position: relative;
`;

export const PopupHeader = styled.div`
  position: relative;
  padding: 20px 16px;
  font-weight: bold;
  font-size: 16px;
  border-bottom: 1px solid #eee;
`;

export const Title = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  color: #666;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #0066ff;
  border-radius: 4px;
  font-size: 14px;
  margin: 16px 0;
  box-sizing: border-box;
  outline: none;

  &:focus {
    border-color: #0066ff;
  }
`;

export const UserList = styled.div`
  background-color: #f5f5f5;
  margin: 0 16px;
  max-height: 250px;
  overflow-y: auto;
  padding: 8px 0;
`;

export const UserOption = styled.div`
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 25px;

  &:hover {
    background-color: #eee;
  }
`;

export const RadioInput = styled.input`
  margin: 0;
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

export const UserLabel = styled.label`
  cursor: pointer;
  font-size: 14px;
`;

export const PopupFooter = styled.div`
  padding: 12px 16px;
  display: flex;
  justify-content: flex-end;
`;

export const ConfirmButton = styled.button`
  padding: 6px 16px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  min-width: 80px;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const PopupContent = styled.div`
  padding: 0 16px;
`;

// Loading indicator styles
export const LoadingContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(245, 245, 245, 0.7);
`;

export const Spinner = styled.div`
  width: 30px;
  height: 30px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #ed2026;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const SelectedWriter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;

export const RemoveWriter = styled.button`
  background: none;
  border: none;
  padding: 0.25rem;
  cursor: pointer;
  color: #9ca3af;
  border-radius: 0.25rem;
`;

export const SelectedWriterName = styled.label`
  font-size: 0.875rem;
  cursor: default;
`;
